import { createFileRoute } from "@tanstack/react-router";

import { DemandRoute } from "../screens/demand-route";

export const Route = createFileRoute("/demand-groups")({
  validateSearch: (search: Record<string, unknown>): { group?: string } =>
    typeof search.group === "string" ? { group: search.group } : {},
  component: DemandRoute,
});
